export default __webpack_public_path__ + "static/media/localization-icon.5207ba17.svg";